import { QueryClient, useQuery as baseUseQuery, useMutation as baseUseMutation } from "@tanstack/react-query";
import ConfigHolder from '../config/ConfigHolder';
import { createIDBPersister } from "./IndexedDBPersister";
import { createNoPersister } from "./NoPersister";
import { createLocalStoragePersister } from "./LocalStoragePersister";
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false
        },
        mutations: {
            retry: 3
        }
    },
});
function createPersister() {
    if (process.env.PERSISTER === 'no') {
        return createNoPersister();
    }
    if (process.env.PERSISTER === 'indexedDb') {
        return createIDBPersister();
    }
    return createLocalStoragePersister();
}
export const persister = createPersister();
const constructHeaders = (params) => {
    let headers = {
        'Content-Type': 'application/json'
    };
    if (ConfigHolder.tokenString) {
        //@ts-ignore
        headers['Authorization'] = 'Bearer ' + ConfigHolder.tokenString;
    }
    return headers;
};
const constructUrl = (endpoint, queryParams) => {
    const url = new URL(endpoint, ConfigHolder.apiBaseUrl);
    if (queryParams) {
        Object.entries(queryParams).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(value => url.searchParams.append(key.concat('[]'), value.toString()));
            }
            else {
                url.searchParams.set(key, value);
            }
        });
    }
    return url.href;
};
const constructError = (status, response) => {
    // const errors = response.json()
    // let error : any = new Error('Error')
    // switch(status) {
    //     case 422:
    //         error : UnprocessableContent = new UnprocessableContent(errors)
    //         break
    //     case 401:
    //         error : Unauthorized = new Unauthorized(errors)
    //         break
    //     case 403:
    //         error : Forbidden = new Forbidden(errors)
    //         break
    //     case 500:
    //         error : HttpError = new HttpError(errors)
    //         break
    // }
    return Promise.reject({ status: status, error: response });
};
//@ts-nocheck
const defaultOptions = {
    method: 'GET',
    headers: constructHeaders()
};
async function fetcher(url, params, options = defaultOptions) {
    return await fetch(constructUrl(url, params), options);
}
export function useMutation(action = "get", endpoint = "/", id, signal) {
    switch (action) {
        case 'do':
            return baseUseMutation({
                mutationFn: async (params) => {
                    const response = await fetcher(endpoint, {}, {
                        method: "POST",
                        headers: constructHeaders(params),
                        body: JSON.stringify(params)
                    });
                    if (!response.ok) {
                        return constructError(response.status, response);
                    }
                    return response.json();
                }
            });
        case 'post':
            return baseUseMutation({
                mutationFn: async (params) => {
                    const response = await fetcher(endpoint, {}, {
                        method: "POST",
                        headers: constructHeaders(params),
                        body: JSON.stringify(params)
                    });
                    if (!response.ok) {
                        return constructError(response.status, response);
                    }
                    return response.json();
                },
                retry: 0,
                // onSuccess: (response: any ) => console.log(response),
                // onError: (response: any) => console.log(response),
                // onMutate: (response: any) => console.log(response),
                // mutationKey: [endpoint],
                // onSuccess(data) {
                //     // update optimistic
                //     console.log(data)
                // },
                // onMutate: async (data) => {
                //     await queryClient.cancelQueries()
                //     // update actual result
                // }
            });
        case 'put':
            return baseUseMutation({
                mutationFn: async (params) => {
                    if (id)
                        endpoint = endpoint.concat('/').concat(id.toString());
                    const response = await fetcher(endpoint, {}, {
                        method: "PUT",
                        headers: constructHeaders(params),
                        body: JSON.stringify(params),
                    });
                    if (!response.ok) {
                        return constructError(response.status, response);
                    }
                    return response.json();
                },
                retry: 0
            });
        case 'delete':
            return baseUseMutation({
                mutationFn: async (params) => {
                    if (id)
                        endpoint = endpoint.concat('/').concat(id.toString());
                    const response = await fetcher(endpoint, {}, {
                        method: "DELETE",
                        headers: constructHeaders(params),
                        body: JSON.stringify(params)
                    });
                    if (!response.ok) {
                        return constructError(response.status, response);
                    }
                    return response.json();
                }
            });
    }
    return baseUseMutation({
        mutationFn: async (params) => {
            const response = await fetcher(endpoint, params, { method: "POST", headers: constructHeaders(params) });
            if (!response.ok) {
                return constructError(response.status, response);
            }
            return response.json();
        }
    });
}
export default function useQuery(action = "get", endpoint = "/", cacheKey = '/', id = 0, params, signal, enabled = true) {
    switch (action) {
        case 'get':
            return baseUseQuery({
                queryKey: [id > 0 ? `${cacheKey}-edit-${id}` : cacheKey],
                networkMode: "offlineFirst",
                cacheTime: 5 * 60 * 1000,
                staleTime: 10 * 60 * 1000,
                enabled: enabled,
                queryFn: async () => {
                    let url = endpoint;
                    if (id !== 0) {
                        url = url.concat('/').concat(id.toString());
                    }
                    const response = await fetcher(url, params, { method: "GET", headers: constructHeaders(params) });
                    if (!response.ok) {
                        return constructError(response.status, response);
                    }
                    return response.json();
                },
                initialData: () => {
                    var _a, _b;
                    //@ts-ignore
                    return (_b = (_a = queryClient.getQueryData([`${cacheKey}-list`])) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.find((row) => {
                        return false;
                        // if(row['id']) return id === row['id']
                        // let parts = row['@id'].split('/')
                        // let _id = parseInt(parts.pop())
                        // return _id === id
                    });
                },
            });
        case 'getAll':
            return baseUseQuery({
                queryKey: [cacheKey],
                networkMode: "offlineFirst",
                cacheTime: 0,
                staleTime: 0,
                enabled: cacheKey !== '',
                queryFn: async () => {
                    const response = await fetcher(endpoint, params, { method: "GET", headers: constructHeaders(params) });
                    if (!response.ok) {
                        return constructError(response.status, response);
                    }
                    return response.json();
                }
            });
    }
    return baseUseQuery({
        queryKey: [cacheKey],
        queryFn: async () => {
            const response = await fetcher(endpoint, { id: params.id });
            if (!response.ok) {
                return constructError(response.status, response);
            }
            return response.json();
        }
    });
}
/**
 * "do" a thing
 *
 * For example, check a token, trigger a server thing, anything that's not specific
 * to a Repository or specifc Entity
 *
 * @param endpoint
 * @param signal
 */
export function useApiDo(endpoint = "/", signal) {
    return useMutation('do', endpoint, 0, signal);
}
/**
 * Get a single entity
 *
 * @param endpoint
 * @param cacheKey
 * @param id
 * @param params
 * @param signal
 */
export function useApiGet(endpoint = "", cacheKey, id, params, signal, enabled = true) {
    const { refetch, isLoading, isError, isSuccess, isRefetching, isFetching, isFetched, data, error } = useQuery('get', endpoint, cacheKey, id, params, signal, enabled);
    return { refetch, isLoading, isError, isSuccess, isRefetching, isFetching, isFetched, data, error };
}
/**
 *
 * Get a repository of entities
 * @param endpoint
 * @param cacheKey
 * @param params
 * @param signal
 */
export function useApiGetAll(endpoint = "", cacheKey, params, signal) {
    const { refetch, isLoading, isError, isSuccess, data, error } = useQuery('getAll', endpoint, cacheKey, params, signal);
    return { refetch, isLoading, isError, isSuccess, data, error };
}
/**
 *
 * Create a new entity
 *
 * @param endpoint
 * @param signal
 */
export function useApiPost(endpoint = "", signal) {
    return useMutation('post', endpoint, 0, signal);
}
/**
 *
 * Update an entity
 *
 * @param endpoint
 * @param id
 * @param signal
 */
export function useApiPut(endpoint = "", id, signal) {
    return useMutation('put', endpoint, id, signal);
}
/**
 *
 * Remove an antity
 *
 * @param endpoint
 * @param id
 * @param signal
 */
export function useApiDelete(endpoint = "", id, signal) {
    return useMutation('delete', endpoint, id, signal);
}
//
// const {data: fetchedResources} = baseUseQuery({
//     queryKey: ['resources'],
//     queryFn: () => fakeApi.getResources(),
//     staleTime: Infinity,
//     cacheTime: Infinity
// })
//
// const updateLocalResourcesList = (
//     id: string,
//     isDone: boolean,
//     isNotSynced?: boolean,
// ) => {
//     queryClient.setQueryData<Resource[]>(['resources'], resourcesList => {
//         return resourcesList?.map(resource => {
//             if (resource.id === id) {
//                 return {
//                     ...resource,
//                     isDone,
//                     isNotSynced
//                 }
//             }
//             return resource
//         })
//     })
// }
//
// export interface Resource {
//     id: string
//     title: string
//     isNotSynced?: boolean
//     isDone: boolean
// }
//
// export interface UpdateResourcePayload {
//     id: string
//     isDone: boolean
// }
//
// const updateExercise = baseUseMutation({
//     mutationKey: ['resources'],
//     mutationFn: async (payload: UpdateResourcePayload) => fetcher('/', {}, {
//             method: "POST",
//             headers: constructHeaders(payload),
//             body: JSON.stringify(payload)
//     }),
//     onSuccess(data) {
//         updateLocalResourcesList(data.id, data.isDone, false)
//     },
//     onMutate: async (payload: UpdateResourcePayload) => {
//         await queryClient.cancelQueries(['resources']);
//         updateLocalResourcesList(payload.id, payload.isDone, true)
//     }
// })
